export default __webpack_public_path__ + "static/media/multi_file.7ef4bd8b.svg";